var map = {
	"./WHMIS.png": 9168,
	"./WHMIS05.png": 7317,
	"./WHMIS06.png": 5838,
	"./WHMIS07.png": 8983,
	"./WHMIS08.png": 2624,
	"./WHMIS09.png": 8873,
	"./WHMIS10.png": 147,
	"./WHMIS11.png": 6042,
	"./WHMIS12.png": 7153,
	"./WHMIS13.png": 6936,
	"./WHMIS14.png": 6551,
	"./WHMIS15.png": 4062,
	"./WHMIS16.png": 9813,
	"./WHMIS17.png": 3900,
	"./WHMIS18.png": 3787,
	"./WHMIS19.png": 8962,
	"./WHMIS20.png": 7938,
	"./WHMIS21.png": 6939,
	"./WHMIS22.png": 8256,
	"./WHMIS23.png": 3081,
	"./WHMIS24.png": 8822,
	"./WHMIS25.png": 6911,
	"./WHMIS26.png": 6996,
	"./WHMIS27.png": 9501,
	"./WHMIS28.png": 5642,
	"./WHMIS29.png": 7219,
	"./WHMIS30.png": 4749,
	"./WHMIS31.png": 3620,
	"./WHMIS32.png": 2527,
	"./WHMIS33.png": 3510,
	"./WHMIS34.png": 6585,
	"./WHMIS35.png": 9680,
	"./WHMIS36.png": 9531,
	"./WHMIS37.png": 8402,
	"./WHMIS38.png": 5349,
	"./WHMIS39.png": 5932,
	"./WHMIS40.png": 9620,
	"./WHMIS41.png": 6301,
	"./WHMIS42.png": 5094,
	"./WHMIS43.png": 4111,
	"./WHMIS44.png": 8240,
	"./WHMIS45.png": 8137,
	"./WHMIS46.png": 6021,
	"./WHMIS47.png": 1912,
	"./WHMIS48.png": 44,
	"./WHMIS49.png": 6581,
	"./WHMIS50.png": 6575,
	"./WHMIS51.png": 8486,
	"./WHMIS52.png": 9165,
	"./WHMIS53.png": 6660,
	"./WHMIS54.png": 6603,
	"./WHMIS55.png": 7602,
	"./WHMIS56.png": 2745,
	"./WHMIS57.png": 7920,
	"./WHMIS58.png": 5191,
	"./WHMIS59.png": 3854,
	"./WHMIS60.png": 894,
	"./WHMIS61.png": 887,
	"./WHMIS62.png": 2156,
	"./WHMIS63.png": 9669,
	"./WHMIS64.png": 5002,
	"./WHMIS65.png": 5763,
	"./WHMIS66.png": 1272,
	"./WHMIS67.png": 3985,
	"./WHMIS68.png": 7830,
	"./WHMISIMG1.png": 7970,
	"./WHMISIMG2.png": 6153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6175;